import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AppAccessGuard } from "./app-access.guard";

import { OneColumnComponent } from "./design/templates/one-column/one-column.component";

import { FormConfirmationComponent } from "./design/structures/form-confirmation/form-confirmation.component";
import { FormUploadComponent } from "./design/structures/form-upload/form-upload.component";
import { FormWelcomeComponent } from "./design/structures/form-welcome/form-welcome.component";
import { OverflowErrorViewComponent } from "./design/structures/overflow-error-view/overflow-error-view.component";

import { ConfirmationComponent } from "./design/pages/confirmation/confirmation.component";
import { OverflowErrorComponent } from "./design/pages/overflow-error/overflow-error.component";
import { UploadComponent } from "./design/pages/upload/upload.component";
import { WelcomeComponent } from "./design/pages/welcome/welcome.component";

import { ToggleService } from "./services/local/toggle.service";

const routes: Routes = [
  { path: "", redirectTo: "welcome", pathMatch: "full" },
  {
    canActivate: [AppAccessGuard],
    component: ConfirmationComponent,
    path: "confirmation",
  },
  {
    canActivate: [AppAccessGuard],
    component: UploadComponent,
    path: "upload",
  },
  {
    canActivate: [AppAccessGuard],
    component: WelcomeComponent,
    path: "welcome",
    resolve: {
      toggle: ToggleService,
    },
  },
  {
    canActivate: [AppAccessGuard],
    component: OverflowErrorComponent,
    path: "overflowerror",
  },
  {
    canActivate: [AppAccessGuard],
    children: [
      { path: "", component: OneColumnComponent, pathMatch: "full" },
      {
        component: FormConfirmationComponent,
        outlet: "part-center",
        path: "formconfirmation",
      },
      {
        component: FormUploadComponent,
        outlet: "part-center",
        path: "formupload",
      },
      {
        component: FormWelcomeComponent,
        outlet: "part-center",
        path: "formwelcome",
      },
      {
        component: OverflowErrorViewComponent,
        outlet: "part-center",
        path: "overflowerrorview",
      },
    ],
    component: OneColumnComponent,
    path: "onecolumn",
  },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes)],
})
export class AppRoutingModule {}
